import React from 'react';
import PropTypes from 'prop-types';
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import get from 'lodash/get';
import classNames from 'classnames';
import classes from '@nerdwallet/base-styles/classes';

import { Button, Text, Box } from '@nerdwallet/currency';
import { ASSETS_SOURCE } from './data';

import './awards-badge-dropdown.less';

const AwardsBadgeDropdownOutput = ({ id, awardsYear }) => {
  const companyName = get(ASSETS_SOURCE[awardsYear], `${id}.name`, {});
  const badgeLink = get(ASSETS_SOURCE[awardsYear], `${id}.badgeLink`, {});

  return (
    <Box>
      <Box className="awards-dropdown__title">
        <Text size="large">Congrats on your win, {companyName}!</Text>
      </Box>
      <Box
        className={classNames([
          'awards-dropdown__button',
          classes('margin-horizontal-auto'),
          classes('text-align-center'),
        ])}
      >
        <Button href={badgeLink}>DOWNLOAD MY ASSETS</Button>
      </Box>
    </Box>
  );
};

AwardsBadgeDropdownOutput.propTypes = {
  id: PropTypes.string,
  awardsYear: PropTypes.string,
};

export default AwardsBadgeDropdownOutput;
